<div class="report-header-shell d-flex align-items-center justify-content-between gap-4 px-4 pt-3 pb-3">
    <img [src]="logoPath" class="report-header-logo" alt="Logo">
    <div class="text-end">
        <h2 class="fs-4 mb-0 mt-1">{{header}}</h2>
    </div>
</div>
